import {
    DropdownContentScroller,
    DropdownContentWrapper,
    DropdownElement,
} from './styles';

export type DropdownElements = {
    elements: {
        id: string;
        value: string;
    }[];
    title: string;
    longestValue: number;
    setCurrentSelected: (d: string) => void;
    className?: string;
};

export const DropdownContent: React.FC<DropdownElements> = ({
    elements,
    longestValue,
    setCurrentSelected,
    className,
}) => {
    return (
        <DropdownContentWrapper className={className}>
            <DropdownContentScroller>
                {elements.map(({ id, value }) => {
                    return (
                        <DropdownElement
                            key={id}
                            onClick={() => setCurrentSelected(value)}
                            style={{ minWidth: `${longestValue}ch` }}
                        >
                            {value}
                        </DropdownElement>
                    );
                })}
            </DropdownContentScroller>
        </DropdownContentWrapper>
    );
};
